import create from '../utils/create';
export default create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      class: _vm.b()
    }, [_vm._t("default")], 2);
  },
  name: 'radio-group',
  props: {
    value: null,
    disabled: Boolean
  },
  watch: {
    value: function value(_value) {
      this.$emit('change', _value);
    }
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vant@1.5.2@vant/es/radio-group/index.js
// module id = null
// module chunks = 